import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ArrowRight, Menu, X } from 'lucide-react'

const navLinks = [
  { label: 'PORTFOLIO', href: '/portfolio' },
  { label: 'SERVICES', href: '/services' },
  { label: 'SOLUTIONS', href: '/solutions/website-development-for-small-business' },
  { label: 'PRICING', href: '/pricing' },
  { label: 'PROCESS', href: '/process' },
  { label: 'TECHNOLOGIES', href: '/technologies' },
  { label: 'ABOUT', href: '/about' },
  { label: 'AWARDS & REVIEWS', href: '/awards' },
  { label: 'BLOG', href: '/blog' },
  { label: 'CONTACT US', href: '/contacts' },
]

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    setMobileOpen(false)
  }, [location])

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-[#050505]/80 backdrop-blur-xl border-b border-white/5'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-6 lg:px-10">
          <div className="flex items-center justify-between h-16 lg:h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-0 shrink-0">
              <img src="/images/logo.png" className='w-24' alt="Technifire Software" />
              <span className="text-[10px] font-medium text-[#9A9A9A] ml-1 hidden sm:inline">
                SOFTWARE
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden xl:flex items-center gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`relative px-3 py-2 text-[11px] font-medium tracking-wide transition-colors hover:text-white ${
                    location.pathname === link.href
                      ? 'text-[#B7000E]'
                      : 'text-[#9A9A9A]'
                  }`}
                >
                  {link.label}
                  {location.pathname === link.href && (
                    <span className="absolute bottom-0 left-3 right-3 h-px bg-[#B7000E]" />
                  )}
                </Link>
              ))}
            </div>

            {/* CTA + Mobile Toggle */}
            <div className="flex items-center gap-3">
              <Link
                to="/contacts"
                className="hidden sm:inline-flex items-center gap-2 h-10 px-5 bg-[#B7000E] text-white rounded-full text-sm font-medium hover:bg-white hover:text-black transition-all hover:-translate-y-0.5"
              >
                BOOK A CALL
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Link>

              <button
                onClick={() => setMobileOpen(!mobileOpen)}
                className="xl:hidden w-10 h-10 flex items-center justify-center text-white"
                aria-label="Toggle menu"
              >
                {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 bg-[#050505] transition-all duration-500 xl:hidden ${
          mobileOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <div className="flex flex-col items-center justify-center h-full gap-6">
          {navLinks.map((link, i) => (
            <Link
              key={link.href}
              to={link.href}
              className="text-2xl font-light text-white hover:text-[#9A9A9A] transition-colors"
              style={{ animationDelay: `${i * 50}ms` }}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contacts"
            className="mt-6 btn-primary"
          >
            BOOK A CALL
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </>
  )
}
